import React from "react";
import { formatPhone } from "../../../utils/FormatPhone";
import { DeliveryTypeTitleEnum } from "../../../enums/DeliveryTypeEnum";
import { capitalizeFirstLetter } from "../../../utils/CapitalizeFirstLetter";
import { RouteShippingStatusEnum } from "../../../enums/DeliveryStatusEnum";
import IconOptionsEnum from "../../../enums/IconOptionsEnum";

export default function ObjectInfo({ loc }) {
  const getStatusColor = (status) => {
    const statusId = status?.length ? status[1]?.id : null
    switch (statusId) {
      case 11:
        return IconOptionsEnum.DELIVERED.color;
      case 12:
        return "#c1c1c1";
      case 13:
        return IconOptionsEnum.PENDING.color;
      default:
        return IconOptionsEnum.UNDELIVERED.color;
    }
  }

  const status = Object.entries(RouteShippingStatusEnum).find(
    st => st[1].id === loc?.status
  );

  const statusColor = getStatusColor(status);

  const title = capitalizeFirstLetter(loc?.client || loc?.origin_or_destination || loc?.driver_name)
  return (
    <div
      style={{
        padding: "0 10px 10px 10px",
        backgroundColor: "#FFF",
        zIndex: 900000000
      }}
    >
      <div style={{
        maxWidth: "420px",
        display: "flex",
        flexDirection: "column",
        gap: "8px",
      }}>
        {title && <h4>{title}</h4>}
        <div style={{
          display: "flex",
          justifyContent: "space-between",
          gap: "8px"
        }}
        >
          {status && status.length && <strong style={{ color: statusColor, fontSize: "16px" }}>{status[1]?.name}</strong>}
          <strong style={{ color: "#409e6a", fontSize: "16px" }}>{DeliveryTypeTitleEnum[loc?.type]}</strong>
        </div>
        {loc?.delivered_in_another_route && (
            <div style={{ marginTop: "4px", padding: "4px 8px", backgroundColor: "#fff9eb", borderLeft: "4px solid #f39c12",borderRadius: "4px"
            }}>
              <span style={{ color: "#d35400", fontSize: "13px", fontWeight: "bold" }}>
                Entregue na Rota: {loc?.delivered_at_route_id}
              </span>
            </div>
        )}
        {loc?.order !== undefined && <div>
          <strong style={{ fontSize: "14px" }}>Ordem: {loc?.order}</strong>
        </div>}
        {loc?.id_route !== undefined && <div>
          <strong style={{ fontSize: "14px" }}>Rota: {loc?.id_route}</strong>
        </div>}

        <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
          {loc?.distance && <span style={{ fontSize: "14px" }}><strong>Distância até o próximo ponto:</strong> {loc?.distance} KM</span>}
          {loc?.client_email && <span style={{ fontSize: "14px" }}><strong>Email:</strong> {loc?.client_email}</span>}
          {loc?.client_phone && <span style={{ fontSize: "14px" }}><strong>Tel.:</strong> {formatPhone(loc?.client_phone)}</span>}
          {loc?.sro && <span style={{ fontSize: "14px" }}><strong>SRO:</strong> {loc?.sro}</span>}
          {loc?.address && <p style={{ fontSize: "14px" }}><strong>Endereço:</strong> {loc?.address}</p>}
        </div>
      </div>
    </div>
  )
}
